import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-config-manager',
  templateUrl: './config-manager.component.html',
  styleUrls: ['./config-manager.component.scss']
})
export class ConfigManagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
